var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component copyright-statement"},[_c('p',[_vm._v("\n    Copyright ©2019 "),_c('strong',[_vm._v("AERGO Enterprise.")]),(_vm.lineBreak)?_c('br'):_vm._e(),_vm._v("\n    All rights reserved.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }